import { graphql } from "lib/generated/app-service-gql";
import {
  BidChatAnsweredSubscription,
  BidChatAnsweredSubscriptionVariables,
} from "lib/generated/app-service-gql/graphql";
import { useSubscription, UseSubscriptionOptions } from "../../useGraphQlClient";

// adding this so it generates the types
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _bidChatAnswered = graphql(`
  subscription bidChatAnswered($conversationId: String!) {
    bidChatAnswered(conversationId: $conversationId) {
      conversationId
      bidId
      question
      answer
      sources {
        document
        documentId
        chunkNumber
        locations {
          pageNumber
          bbox {
            x
            y
            width
            height
          }
        }
      }
      isComplete
    }
  }
`);

export function useBidChatSubscription(
  conversationId: string | undefined,
  options?: UseSubscriptionOptions<BidChatAnsweredSubscription>,
) {
  const { data, ...rest } = useSubscription<
    BidChatAnsweredSubscription,
    BidChatAnsweredSubscriptionVariables
  >(
    `
subscription bidChatAnswered($conversationId: String!) {
  bidChatAnswered(conversationId: $conversationId) {
    conversationId
    bidId
    question
    answer
    sources {
        document
        documentId
        chunkNumber
        locations {
          pageNumber
          bbox {
            x
            y
            width
            height
          }
        }
      }
    isComplete
  }
}
`,
    { conversationId: conversationId || "" },
    {
      ...options,
      enabled: !!conversationId && !!window.currentUser,

      // This is where you update the bid Ask AI questions query in the cache
      // TODO: Implement query cache update to update questions that have been asked before on the bid report

      // onData: (data) => {

      //   client.setQueryData(
      //     ["questions", { conversationId: data.bidChatAnswered.conversationId }],
      //     (oldData: { getQuestions: Question[] } | undefined) => {
      //       if (data.bidChatAnswered.isComplete && oldData) {
      //         const updatedData = [
      //           {
      //             ...data.bidChatAnswered,
      //             responseReceivedAt: new Date().toISOString(),
      //           },
      //           ...oldData.getQuestions,
      //         ];
      // TODO: Add logging here
      // logEvents(
      //   bidChatAnswered(
      //     data.bidChatAnswered.question,
      //     data.bidChatAnswered.id,
      //     data.bidChatAnswered.answer || "",
      //     orgName,
      //   ),
      // );
      //         return {
      //           getQuestions: updatedData,
      //         };
      //       } else {
      //         return oldData;
      //       }
      //     },
      //   );
      // },
    },
  );

  return { data: data?.bidChatAnswered, ...rest };
}
